import { Pipe, PipeTransform } from '@angular/core'
import { ProductMove } from 'depoto-core/src/entities'

@Pipe({
  name: 'operationsPriceSum',
  pure: false,
})
export class OperationsPriceSumPipe implements PipeTransform {
  transform(value: ProductMove[], args: string[]): any {
    if (!value || (value && value.length < 1)) {
      return '0'
    }
    let resArr: any[] = []
    switch (args[0]) {
      case 'sell':
        resArr = value.map(item => {
          return item.sellPriceSum
        })
        break
      case 'purchase':
        // resArr = value.map(item => {
        //   // this is no longer needed, as operations are given as whole packages now (2025/07). leave commented for reference.
        //   // well, fuck this shit. it is used on move out, not on move in.. so, we need another arg
        //   // note: fuck your pieces vs packages tags. we have fucking productbundles exactly for that. fuck!
        //   // if (item.product?.tags?.some(tag => tag.externalId === 'hs-count-by-piece')) {
        //   //   return item.purchasePriceSum / item.product.packs?.[0]?.quantity
        //   // }
        //   return item.purchasePriceSum
        // });
        if (args[1] === 'in') {
          resArr = value.map(item => {
            // this is no longer needed, as operations are given as whole packages now (2025/07). leave commented for reference.
            // well, fuck this shit. it is used on move out, not on move in.. so, we need another arg
            // note: fuck your pieces vs packages tags. we have fucking productbundles exactly for that. fuck!
            if (item.product?.tags?.some(tag => tag.externalId === 'hs-count-by-piece')) {
              return item.purchasePriceSum / item.product.packs?.[0]?.quantity
            }
            return item.purchasePriceSum
          })
        } else if (args[1] === 'out') {
          resArr = value.map(item => {
            // this is no longer needed, as operations are given as whole packages now (2025/07). leave commented for reference.
            // well, fuck this shit. it is used on move out, not on move in.. so, we need another arg
            // note: fuck your pieces vs packages tags. we have fucking productbundles exactly for that. fuck!
            // if (item.product?.tags?.some(tag => tag.externalId === 'hs-count-by-piece')) {
            //   return item.purchasePriceSum / item.product.packs?.[0]?.quantity
            // }
            return item.purchasePriceSum
          })
        }
        break
      case 'quantity':
        return value
          .map(item => {
            return item.amount
          })
          .reduce((sum, amount) => {
            return Number(sum) + Number(amount)
          })
    }
    const sum =
      resArr && resArr.length
        ? Number(
            resArr.reduce((sum, amount) => {
              return Number(sum) + Number(amount)
            }),
          ).toFixed(2)
        : '0.00'
    return Number(sum)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
}
